import FromTo from './FromTo'

export default FromTo
